import { default as AkModal } from '@atlaskit/modal-dialog/modal-dialog';
import type { ModalDialogProps as AkModalDialogProps } from '@atlaskit/modal-dialog/types';

import type {
	ChoreographedComponentProps,
	ChoreographerMessageTypes,
	ChoreographerUtilities,
} from '../../types';
import { wrapComponentForChoreographer } from '../utils';

export const Modal: {
	({
		shouldBeChoreographed,
		withChoreographedRender,
		...props
	}: AkModalDialogProps &
		ChoreographerUtilities &
		Partial<ChoreographedComponentProps> & {
			messageType?: ChoreographerMessageTypes;
		}): React.JSX.Element;
	displayName: string;
} = wrapComponentForChoreographer<AkModalDialogProps>(AkModal);
